exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logintext {\n  padding-right: 5px;\n}\n.logintext--left {\n  text-align: left;\n}\n.login--no-bottom-margin {\n  margin-bottom: 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/reset-password/reset-password.component.scss
// module id = ../../../../../src/app/components/reset-password/reset-password.component.scss
// module chunks = main